.item {
  border-bottom: 1px solid var(--color-background);
  color: var(--color-text);
  margin-bottom: 2rem;
  padding-bottom: 1rem;
}

.date {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.body {
  white-space: pre-wrap;
}
